import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-consulta-gravame',
  templateUrl: './consulta-gravame.component.html',
  styleUrls: ['./consulta-gravame.component.scss']
})
export class ConsultaGravameComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.setStatus();
  }

  setStatus() {
    this.consulta.statusGravame && this.consulta.statusGravame === 'ativo' ? this.status = 'warning' : this.status;
    this.consulta.statusGravame && this.consulta.statusGravame === 'baixado' ? this.status = 'success' : this.status;
    this.consulta.statusGravame && this.consulta.statusGravame === 'cancelado' ? this.status = 'success' : this.status;
    this.consulta.statusGravame && this.consulta.statusGravame === 'nada consta' ? this.status = 'success' : this.status;
    this.consulta.statusGravame && this.consulta.statusGravame === 'sem detalhamento' ? this.status = 'disabled' : this.status;
  }

}
